import React from 'react'

export default function Footer() {
    return (
        <footer className="main-footer">
            <strong>Copyright &copy; 2021 <a href="#">Farmsens</a>.</strong>
            All rights reserved.
            <div className="float-right d-none d-sm-inline-block">
                <b>Version</b> 3.1.0
            </div>
        </footer>
    )
}
